/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', (e) => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    const emailAddress = this.els.email.element.value

    this.KlaviyoSubmission(variantId, emailAddress)

    if (!this?.els?.newsletter?.exists) return

    if (this.els.newsletter.element.checked === true) {
      this.newsletterSubscribe(emailAddress)
    }
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    // Docs: https://developers.klaviyo.com/en/reference/create_client_back_in_stock_subscription
    try {
      const request = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailAddress,
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        },
      )

      if (request.status === 202) {
        this.showSuccess()
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  async newsletterSubscribe (emailAddress) {
    // Docs: https://developers.klaviyo.com/en/reference/create_client_subscription
    try {
      const request = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        {
          method: 'POST',
          headers: {
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailAddress,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: window.theme.klaviyo.newsletterListID,
                  },
                },
              },
            },
          }),
        },
      )

      if (request.status === 202) {
        this.showNewsletterSuccess()
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }

  showNewsletterSuccess () {
    this.els['newsletter-success-label'].element.setAttribute(
      'aria-hidden',
      false,
    )
    this.els['newsletter-label'].element.setAttribute('aria-hidden', true)

    this.els.newsletter.element.disabled = true
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
